import * as React from 'react'
import { DualColRow } from 'src/components/common/DualColRow/DualColRow'
import { DisbursementTriggerLabel } from 'src/services/Enum/DisbursementTriggerEnum'
import { ITrade } from 'src/services/interfaces/trade/ITrade'
import { formatDate } from 'src/util/Date.helper'

interface IDisbursementInfoProps {
  trade?: ITrade
}

export const DisbursementInfo: React.FC<IDisbursementInfoProps> = ({ trade: { phase, tradePricing: { pricing } } }) => {
  return (<>
    <DualColRow title="Data de desembolso:" />
    {pricing?.pricingDisbursements?.map(({ trigger, expectedDate }) => (
      <div className="row">
        <span className="left description">
          Desembolso em {DisbursementTriggerLabel.get(trigger)} (Previsão):
        </span>
        <span className="right description">{formatDate(expectedDate)}</span>
      </div>
    ))}
  </>)
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/PricingInfo/DisbursementInfo.tsx